import httpUserClient from '@/plugins/httpUserClient';

export default {
  index(type, page, perPage) {
    return httpUserClient.get(`user/${type}?page=${page}&per_page=${perPage}`);
  },
};



// WEBPACK FOOTER //
// ./src/apiSet/api-userAttach.js